import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import { Radio as MuiRadio, FormControlLabel as MuiFormControlLabel, } from '@material-ui/core';
import { ThemeProvider, useTheme } from "../../hooks/useTheme";
import { makeStyles } from "../../styles/index";
import { Typography } from "../Typography/Typography";
import { RadioButtonIcon } from "./RadioButtonIcon";
var useStyles = makeStyles(function (theme) { return ({
    root: {},
    label: {
        userSelect: 'none',
    },
    labelDisabled: {
        '&$light': {
            color: theme.palette.light.action.disabled,
        },
        '&$dark': {
            color: theme.palette.dark.action.disabled,
        },
    },
    light: {},
    dark: {},
    // hover時のhaloエフェクトを上書きにより無効化
    radioRoot: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&$radioColorSecondary$radioChecked:hover': {
            backgroundColor: 'transparent',
        },
    },
    radioChecked: {},
    radioColorSecondary: {},
}); }, { name: 'SnRadioButton' });
export var RadioButton = React.forwardRef(function (props, ref) {
    var _a;
    var dark = props.dark, light = props.light, className = props.className, label = props.label, children = props.children, labelPlacement = props.labelPlacement, value = props.value, disabled = props.disabled, onChange = props.onChange, onClick = props.onClick;
    var classes = useStyles(props);
    var theme = useTheme({ dark: dark, light: light });
    var handleChange = useCallback(function (event, checked) {
        event.persist();
        onChange === null || onChange === void 0 ? void 0 : onChange(event, checked);
    }, [onChange]);
    // MuiのRadioの中で使われるIconButtonにPointerEventを伝搬する方法がないためstateで管理する。
    var _b = useState(false), hover = _b[0], setHover = _b[1];
    var _c = useState(false), active = _c[0], setActive = _c[1];
    var handleMouseEnter = useCallback(function () { return setHover(true); }, []);
    var handleMouseLeave = useCallback(function () {
        setHover(false);
        setActive(false);
    }, []);
    var handleMouseDown = useCallback(function () { return setActive(true); }, []);
    var handleMouseUp = useCallback(function () { return setActive(false); }, []);
    var labelClassNames = classNames(classes.label, classes[theme.type], (_a = {},
        _a[classes.labelDisabled] = disabled,
        _a));
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(MuiFormControlLabel, { className: className, ref: ref, value: value, disabled: disabled, labelPlacement: labelPlacement, label: React.createElement(Typography, { variant: "body1", className: labelClassNames }, label !== undefined ? label : children), control: React.createElement(MuiRadio, { disableRipple: true, classes: {
                    root: classes.radioRoot,
                    checked: classes.radioChecked,
                    colorSecondary: classes.radioColorSecondary,
                }, icon: React.createElement(RadioButtonIcon, { hover: hover, active: active, disabled: disabled, light: light, dark: dark }), checkedIcon: React.createElement(RadioButtonIcon, { checked: true, hover: hover, active: active, disabled: disabled, light: light, dark: dark }) }), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onChange: handleChange, onClick: onClick })));
});
